export default "/_next/static/images/stethoscope-2x-b961ca83d9c658874629fa9a86464ee2.jpg";